<link href="https://fonts.googleapis.com/css2?family=Raleway:wght@400;500;600;700&display=swap" rel="stylesheet">
<div class="calculators-container">
  <div class="header">
    <div class="language-selector">
      <button 
      (click)="changeLanguage('en')" 
      [class.active]="translate.currentLang === 'en'"
      class="lang-btn">EN</button>
      <button 
        (click)="changeLanguage('es')" 
        [class.active]="translate.currentLang === 'es'"
        class="lang-btn">ES</button>
      <button 
        (click)="changeLanguage('pl')" 
        [class.active]="translate.currentLang === 'pl'"
        class="lang-btn">PL</button>
    </div>
    <h1>{{ 'calculator.title' | translate }}</h1>
    <p class="subtitle">{{ 'calculator.subtitle' | translate }}</p>
  </div>

  <div class="calculator-content">
    <div class="input-section">
      <h2>{{ 'calculator.basicParams' | translate }}</h2>
      
      <div class="input-grid">
        <div class="input-group">
          <label for="currency">{{ 'calculator.currency' | translate }}</label>
          <select 
            id="currency"
            [(ngModel)]="inputs.currency" 
            (ngModelChange)="calculate()"
            class="input-field">
            <option value="USD">USD</option>
            <option value="EUR">EUR</option>
            <option value="PLN">PLN</option>
          </select>
        </div>

        <div class="input-group">
          <label for="totalEmployees">{{ 'calculator.totalEmployees' | translate }}</label>
          <input 
            type="number" 
            id="totalEmployees"
            [(ngModel)]="inputs.totalEmployees" 
            (ngModelChange)="calculate()"
            min="1"
            class="input-field">
        </div>

        <div class="input-group">
          <label for="itAdminHourlyRate">{{ 'calculator.itAdminHourlyRate' | translate }}</label>
          <input 
            type="number" 
            id="itAdminHourlyRate"
            [(ngModel)]="inputs.itAdminHourlyRate" 
            (ngModelChange)="calculate()"
            min="1"
            step="0.01"
            class="input-field">
        </div>

        <div class="input-group">
          <label for="weeklyHoursSpentOnSignatures">{{ 'calculator.weeklyHoursSpentOnSignatures' | translate }}</label>
          <input 
            type="text" 
            id="weeklyHoursSpentOnSignatures"
            [value]="formatNumberWithDecimals(inputs.weeklyHoursSpentOnSignatures, 4)"
            class="input-field locked"
            readonly>
        </div>
      </div>

      <h2>{{ 'calculator.businessParams' | translate }}</h2>
      
      <div class="input-grid">
        <div class="input-group">
          <label for="averageMonthlyRevenuePerCustomer">{{ 'calculator.averageMonthlyRevenuePerCustomer' | translate }}</label>
          <input 
            type="number" 
            id="averageMonthlyRevenuePerCustomer"
            [(ngModel)]="inputs.averageMonthlyRevenuePerCustomer" 
            (ngModelChange)="calculate()"
            min="1"
            step="0.01"
            class="input-field">
        </div>

        <div class="input-group">
          <label for="websiteConversionRate">{{ 'calculator.websiteConversionRate' | translate }}</label>
          <div class="slider-container">
            <input 
              type="range" 
              id="websiteConversionRate"
              [(ngModel)]="inputs.websiteConversionRate" 
              (ngModelChange)="calculate()"
              min="1"
              max="10"
              step="0.1"
              class="slider">
            <span class="slider-value">{{ inputs.websiteConversionRate }}%</span>
          </div>
        </div>

        <div class="input-group">
          <label for="leadToCustomerConversionRate">{{ 'calculator.leadToCustomerConversionRate' | translate }}</label>
          <div class="slider-container">
            <input 
              type="range" 
              id="leadToCustomerConversionRate"
              [(ngModel)]="inputs.leadToCustomerConversionRate" 
              (ngModelChange)="calculate()"
              min="10"
              max="40"
              step="0.1"
              class="slider">
            <span class="slider-value">{{ inputs.leadToCustomerConversionRate }}%</span>
          </div>
        </div>

        <div class="input-group">
          <label for="ctr">{{ 'calculator.ctr' | translate }}</label>
          <div class="slider-container">
            <input 
              type="range" 
              id="ctr"
              [(ngModel)]="inputs.ctr" 
              (ngModelChange)="calculate()"
              min="0.5"
              max="5"
              step="0.1"
              class="slider">
            <span class="slider-value">{{ inputs.ctr }}%</span>
          </div>
        </div>

        <div class="input-group">
          <label for="monthlyEmailsSent">{{ 'calculator.monthlyEmailsSent' | translate }}</label>
          <input 
            type="number" 
            id="monthlyEmailsSent"
            [(ngModel)]="inputs.monthlyEmailsSent" 
            (ngModelChange)="calculate()"
            min="1"
            class="input-field locked"
            readonly>
        </div>

        <div class="input-group">
          <label for="averageEmailsPerEmployee">{{ 'calculator.averageEmailsPerEmployee' | translate }}</label>
          <div class="slider-container">
            <input 
              type="range" 
              id="averageEmailsPerEmployee"
              [(ngModel)]="inputs.averageEmailsPerEmployee" 
              (ngModelChange)="calculate()"
              min="200"
              max="600"
              step="10"
              class="slider">
            <span class="slider-value">{{ inputs.averageEmailsPerEmployee }}</span>
          </div>
        </div>

        <div class="input-group">
          <label for="maintenanceTimePercentage">{{ 'calculator.maintenanceTimePercentage' | translate }}</label>
          <div class="slider-container">
            <input 
              type="range" 
              id="maintenanceTimePercentage"
              [(ngModel)]="inputs.maintenanceTimePercentage" 
              (ngModelChange)="calculate()"
              min="5"
              max="25"
              step="0.1"
              class="slider">
            <span class="slider-value">{{ inputs.maintenanceTimePercentage }}%</span>
          </div>
        </div>
      </div>

      <h2>{{ 'calculator.saveSettings' | translate }}</h2>
      
      <div class="save-section">
        <div class="input-group full-width">
          <label for="email">{{ 'calculator.email' | translate }}</label>
          <div class="email-input-container">
            <input 
              type="email" 
              id="email"
              [(ngModel)]="inputs.email" 
              required
              class="input-field email-input"
              [class.error]="getEmailErrorClass()">
            <button 
              type="button"
              class="send-button"
              [disabled]="!isFormValid() || isSending"
              (click)="sendCalculatorLink()">
              <span *ngIf="!isSending">{{ 'calculator.save' | translate }}</span>
              <span *ngIf="isSending">{{ 'calculator.saving' | translate }}</span>
            </button>
          </div>
        </div>

        <div class="input-group checkbox-group full-width">
          <label class="checkbox-label">
            <input 
              type="checkbox" 
              id="termsAccepted"
              [(ngModel)]="inputs.termsAccepted" 
              required
              class="checkbox-input"
              [class.error]="getTermsErrorClass()">
            <span class="checkbox-text">
              {{ 'calculator.termsDisclaimer' | translate }} 
              <a [href]="getTermsOfServiceUrl()" target="_blank" class="terms-link">
                {{ 'calculator.termsOfService' | translate }}
              </a>
            </span>
          </label>
        </div>
      </div>

      <div class="message-container" *ngIf="showSuccessMessage || showErrorMessage">
        <div class="success-message" *ngIf="showSuccessMessage">
          {{ 'calculator.linkSent' | translate }}
        </div>
        <div class="error-message" *ngIf="showErrorMessage">
          {{ 'calculator.linkSentError' | translate }}
        </div>
      </div>
    </div>

    <div class="results-section">
      <h2>{{ 'calculator.results' | translate }}</h2>
      
      <div class="results-grid">
        <div class="result-card">
          <div class="result-label">{{ 'calculator.gSignatureCost' | translate }}</div>
          <div class="result-value">{{ formatNumber(results.gSignatureCost) }} {{ inputs.currency }}</div>
        </div>

        <div class="result-card">
          <div class="result-label">{{ 'calculator.monthlyAdminCost' | translate }}</div>
          <div class="result-value">{{ formatNumber(results.monthlyAdminCost) }} {{ inputs.currency }}</div>
        </div>

        <div class="result-card">
          <div class="result-label">{{ 'calculator.monthlyLeadsFromClicks' | translate }}</div>
          <div class="result-value">{{ formatNumber(results.monthlyLeadsFromClicks) }}</div>
        </div>

        <div class="result-card">
          <div class="result-label">{{ 'calculator.monthlyClicksFromSignatures' | translate }}</div>
          <div class="result-value">{{ formatNumber(results.monthlyClicksFromSignatures) }}</div>
        </div>

        <div class="result-card">
          <div class="result-label">{{ 'calculator.monthlyNewCustomers' | translate }}</div>
          <div class="result-value">{{ formatNumber(results.monthlyNewCustomers) }}</div>
        </div>

        <div class="result-card highlight-tile">
          <div class="result-label">{{ 'calculator.monthlyAdminSavings' | translate }}</div>
          <div class="result-value">{{ formatNumber(results.monthlyAdminSavings) }} {{ inputs.currency }}</div>
        </div>

        <div class="result-card">
          <div class="result-label">{{ 'calculator.monthlyRevenueFromCustomers' | translate }}</div>
          <div class="result-value">{{ formatNumber(results.monthlyRevenueFromCustomers) }} {{ inputs.currency }}</div>
        </div>

        <div class="result-card">
          <div class="result-label">{{ 'calculator.timeSavedPercentage' | translate }}</div>
          <div class="result-value">{{ formatNumber(results.timeSavedPercentage) }}%</div>
        </div>

        <div class="result-card highlight">
          <div class="result-label">{{ 'calculator.monthlyTotalProfit' | translate }}</div>
          <div class="result-value">{{ formatNumber(results.monthlyTotalProfit) }} {{ inputs.currency }}</div>
        </div>

        <div class="result-card">
          <div class="result-label">{{ 'calculator.roiItAdmin' | translate }}</div>
          <div class="result-value">{{ formatNumber(results.roiItAdmin) }}%</div>
          <small class="help-text">{{ 'calculator.roiItAdminFormula' | translate }}</small>
        </div>

        <div class="result-card">
          <div class="result-label">{{ 'calculator.roiMarketing' | translate }}</div>
          <div class="result-value">{{ formatNumber(results.roiMarketing) }}%</div>
          <small class="help-text">{{ 'calculator.roiMarketingFormula' | translate }}</small>
        </div>

        <div class="result-card highlight">
          <div class="result-label">{{ 'calculator.totalRoi' | translate }}</div>
          <div class="result-value">{{ formatNumber(results.totalRoi) }}%</div>
        </div>
      </div>
    </div>
  </div>
</div>